import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TimestampService } from '../../../../utilities/timestamp/timestamp.service';

import * as _ from 'lodash';
import { DateService } from '../../../../utilities/date/date.service';
import { CustomFieldsMapped } from '../models/custom-field';

@Component({
  selector: 'tn-field-time',
  templateUrl: './field-time.component.html',
  styleUrls: ['./field-time.component.scss'],
  host: { 'component-root': 'shared' }
})
export class FieldTimeComponent implements OnInit {

  @Input() field: CustomFieldsMapped;
  @Input() isInput: boolean = false;

  @Output() onFieldUpdate: EventEmitter<CustomFieldsMapped> = new EventEmitter<CustomFieldsMapped>(null);

  timeDisplay: string;

  timeInput: Date = null;

  constructor(
    private _timestampService: TimestampService,
    private _dateService: DateService
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.field.answer.value) {
      this.timeDisplay = this._dateService.getDateDisplayWithKey(
        this.field.answer.value,
        "FORM_DETAIL_REPORT_TIME"
      );
      this.timeInput = this._timestampService.secondToDateObj(this.field.answer.value);
    }
  }

  getAnswerValue(): string {
    return this.timeInput ? this._timestampService.dateObjToSecondString(this.timeInput) : "";;
  }

  onChange() {
    this.field.answer.value = this.getAnswerValue();
    this.onFieldUpdate.emit(this.field);
  }

}
